import React, { useState } from 'react';
import { Input } from '@chakra-ui/core';
import { colors } from '../../styles/theme-chakra';

const TextInput = ({ value, onChange, ...props }) => {
  const [val, setVal] = useState(value || '');

  const updateVal = e => {
    setVal(e.target.value);
    onChange(e.target.value);
    e.preventDefault();
  };
  return (
    <Input
      mt="2rem"
      borderColor={colors.black}
      borderRadius="10px"
      onChange={updateVal}
      focusBorderColor="#00000055"
      bg={colors.white}
      value={val}
      {...props}
    />
  );
};

export default TextInput;
